module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-5931986200275d406ac91f7286b2a331.png";